// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCCQg10mpuqJdVsKmdXCOxutq3xQsia0HU',
  authDomain: 'fixsystem-17a31.firebaseapp.com',
  projectId: 'fixsystem-17a31',
  storageBucket: 'fixsystem-17a31.appspot.com',
  messagingSenderId: '546650093449',
  appId: '1:546650093449:web:9c32f028dd8e44ef3c5358',
  measurementId: 'G-GCK9MXGLBK',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

self.addEventListener('push', function (e) {
  const data = e.data.json()
  const options = {
    body: data.notification.body,
    icon: data.notification.icon,
    vibrate: [100, 50, 100],
    data: {
      dateOfArrival: Date.now(),
      primaryKey: '2',
    },
  }
  self.registration.showNotification(data.notification.title, options)
})

const analytics = getAnalytics(app)
const messaging = getMessaging(app)

export default { messaging, getToken, analytics, onMessage }

// import firebase from 'firebase/app'
// import 'firebase/firebase-messaging'

// const firebaseConfig = {
//   apiKey: 'AIzaSyCCQg10mpuqJdVsKmdXCOxutq3xQsia0HU',
//   authDomain: 'fixsystem-17a31.firebaseapp.com',
//   projectId: 'fixsystem-17a31',
//   storageBucket: 'fixsystem-17a31.appspot.com',
//   messagingSenderId: '546650093449',
//   appId: '1:546650093449:web:9c32f028dd8e44ef3c5358',
//   measurementId: 'G-GCK9MXGLBK',
// }

// firebase.initializeApp(firebaseConfig)

// export default firebase.messaging()
